'use client'

import { Controller } from 'react-hook-form'
import ProfileImageInput from '../../../components/ProfileImageInput'
import { MultistepForm } from '../../../components/Multistep'

interface Props {
    form: MultistepForm<any>
    showDescription?: boolean
}

export default function ProfileImageStep({ form, showDescription = true }: Props) {
    const { control } = form

    return (
        <Controller
            control={control}
            name='image'
            render={({ field }) => (
                <ProfileImageInput
                    value={field.value}
                    onChange={(value: string | undefined) => field.onChange(value)}
                    onRemove={() => field.onChange(undefined)}
                    showDescription={showDescription}
                />
            )}
        />
    )
}
